import { getCookie } from "@directv-digital/dds.services.cookie-service";

/**
  * Deletes a cookie by setting its expiration date to the past.
  * @param {string} cookieName - The name of the cookie to delete.
  * @return {void}
  * @description This function checks if the cookie exists, and if it does, it sets the cookie's value to an empty string and its expiration date to a past date, effectively deleting it.
  * Usage: Call this function with the cookie name to delete the cookie globally.
  * Example: deleteCookie("intent");
  */
export const deleteCookie = (cookieName: string) => {
  try {
    const cookieValue = getCookie(cookieName);
    if (cookieValue) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      console.log(`Cookie "${cookieName}" deleted globally.`);
    } else {
      console.log(`Cookie "${cookieName}" not found.`);
    }
  } catch (error) {
    console.error(`Error deleting cookie "${cookieName}":`, error);
  }
};
